import { useCallback } from 'react';
import { dashboardService } from '@/services/api';
import type { TaskChartDataPoint } from '@/pages/DashboardPage/components/TaskOverviewSection/TaskOverviewSection.types';
import { useDashboardQuery } from './useDashboardQuery';

interface UseDashboardTaskProgressReturn {
  taskProgress: TaskChartDataPoint[] | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useDashboardTaskProgress(
  dateRange: string
): UseDashboardTaskProgressReturn {
  const fetcher = useCallback(
    () => dashboardService.getTaskProgress(dateRange),
    [dateRange]
  );
  const {
    data: taskProgress,
    isLoading,
    error,
    refresh,
  } = useDashboardQuery(fetcher, 'Failed to fetch task progress');
  return { taskProgress, isLoading, error, refresh };
}
